import "vite/modulepreload-polyfill";
import "../scss/style.scss";
import * as bootstrap from "bootstrap";
import $ from "jquery";

// Set globals for any inline scripts
window.bootstrap = bootstrap;
window.$ = window.jQuery = $;
